export default "__VITE_ASSET__r1xLf93k__"